/**
 * Theme JS after load.
 * Heavy third parties (WPM, Judge.me, Langify, insurance, …) hydrate only after interaction.
 * Homepage Swiper loads only after the user scrolls near the slider (no eager video download).
 */
(function () {
  'use strict';

  if (window.__themeAfterLoadBooted) return;
  window.__themeAfterLoadBooted = true;
  window.themeScriptsLoaded = false;

  var ENABLE_KLAVIYO_POPUP = false;
  var SWIPER_JS = (window.__themeAssets && window.__themeAssets.swiperJs) || '';
  var SWIPER_CSS = (window.__themeAssets && window.__themeAssets.swiperCss) || '';

  function resolveSwiperEager() {
    var v = window.__themeAssets && window.__themeAssets.swiperEager;
    // Broken Liquid previously emitted the string "index" (truthy) on homepage.
    if (v === true) return true;
    if (v === false || v === 'index') return false;
    var path = (location.pathname || '/').replace(/\/+$/, '') || '/';
    if (path === '/' || path === '/en' || path === '/ar') return false;
    return !!v;
  }

  var SWIPER_EAGER = resolveSwiperEager();

  function loadScript(src) {
    return new Promise(function (resolve) {
      if (!src || src === 'about:blank') return resolve();
      if (document.querySelector('script[data-theme-loaded-src="' + src + '"]')) return resolve();
      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      s.dataset.themeLoadedSrc = src;
      s.onload = function () { resolve(); };
      s.onerror = function () { resolve(); };
      document.body.appendChild(s);
    });
  }

  function loadStylesheet(href) {
    if (!href || document.querySelector('link[data-theme-loaded-href="' + href + '"]')) return;
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = href;
    l.dataset.themeLoadedHref = href;
    document.head.appendChild(l);
  }

  function isSwiperAsset(src) {
    return src && src.indexOf('swiper-bundle.min.js') !== -1;
  }

  function runThemeQueue() {
    var nodes = document.querySelectorAll('script[type="text/deferred-theme-js"][data-src]');
    var urls = [];
    var seen = {};
    nodes.forEach(function (node) {
      var src = node.getAttribute('data-src');
      if (!src || seen[src]) return;
      if (!SWIPER_EAGER && isSwiperAsset(src)) return;
      seen[src] = true;
      urls.push(src);
    });

    var chain = Promise.resolve();
    if (SWIPER_EAGER && SWIPER_CSS) loadStylesheet(SWIPER_CSS);
    urls.forEach(function (src) {
      chain = chain.then(function () { return loadScript(src); });
    });

    return chain.then(function () {
      window.themeScriptsLoaded = true;
      document.documentElement.classList.add('lcp-ready');
      document.dispatchEvent(new CustomEvent('theme:scripts:loaded'));
    });
  }

  window.ensureSwiper = function ensureSwiper() {
    if (typeof Swiper !== 'undefined') return Promise.resolve();
    if (window.__swiperLoading) return window.__swiperLoading;

    var src = SWIPER_JS;
    if (!src) {
      var marker = document.querySelector('script[type="text/deferred-theme-js"][data-src*="swiper-bundle.min.js"]');
      if (marker) src = marker.getAttribute('data-src');
    }
    if (!src) return Promise.resolve();

    if (SWIPER_CSS) loadStylesheet(SWIPER_CSS);

    window.__swiperLoading = loadScript(src).then(function () {
      window.__swiperLoading = null;
    });
    return window.__swiperLoading;
  };

  function hydrateDeferredScripts(selector) {
    document.querySelectorAll(selector).forEach(function (old) {
      var s = document.createElement('script');
      var src = old.getAttribute('data-src');
      if (src) {
        if (src === 'about:blank') {
          old.parentNode.removeChild(old);
          return;
        }
        s.src = src;
        s.async = true;
      } else {
        s.text = old.textContent;
      }
      Array.prototype.forEach.call(old.attributes, function (attr) {
        if (attr.name === 'type' || attr.name === 'data-src' || attr.name === 'src') return;
        s.setAttribute(attr.name, attr.value);
      });
      old.parentNode.replaceChild(s, old);
    });
  }

  function isLangifySrc(src) {
    return /langify|lably\.js/i.test(src || '');
  }

  function releaseScript(old) {
    var s = document.createElement('script');
    var src = old.getAttribute('data-src');
    if (src) {
      if (src === 'about:blank') {
        if (old.parentNode) old.parentNode.removeChild(old);
        return;
      }
      s.src = src;
      s.async = true;
    } else {
      s.text = old.textContent;
    }
    Array.prototype.forEach.call(old.attributes, function (attr) {
      if (attr.name === 'type' || attr.name === 'data-src' || attr.name === 'src') return;
      s.setAttribute(attr.name, attr.value);
    });
    if (old.parentNode) old.parentNode.replaceChild(s, old);
  }

  function hydrateLangifyNow() {
    var queued = window.__tpScriptQueue || [];
    var keep = [];
    queued.forEach(function (el) {
      var src = (el && el.getAttribute && el.getAttribute('data-src')) || '';
      if (!isLangifySrc(src)) {
        keep.push(el);
        return;
      }
      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      document.body.appendChild(s);
    });
    window.__tpScriptQueue = keep;

    document.querySelectorAll('script[type="text/tp-deferred"][data-src], script[type="text/lazyloadscript"][data-delayed-src]').forEach(function (old) {
      var src = old.getAttribute('data-src') || old.getAttribute('data-delayed-src') || '';
      if (!isLangifySrc(src)) return;
      if (!old.getAttribute('data-src') && src) old.setAttribute('data-src', src);
      releaseScript(old);
    });
  }

  function hydrateThirdParties() {
    if (window.__tpHydrated) return;
    window.__tpHydrated = true;
    window.__tpAllowHeavy = true;

    // Scripts intercepted by snippets/meta-tags.liquid gate
    var queued = window.__tpScriptQueue || [];
    queued.forEach(function (el) {
      var src = el.getAttribute('data-src');
      if (!src || src === 'about:blank') return;
      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      document.body.appendChild(s);
    });
    window.__tpScriptQueue = [];

    hydrateDeferredScripts('script[type="text/tp-deferred"]');
    hydrateDeferredScripts('script[type="text/wpm-deferred"]');
    hydrateDeferredScripts('script[type="text/klaviyo-deferred"]');
  }

  window.hydrateThirdParties = hydrateThirdParties;

  function armHeavyOnInteraction() {
    var done = false;
    function go() {
      if (done) return;
      done = true;
      ['scroll', 'pointerdown', 'touchstart', 'keydown'].forEach(function (evt) {
        window.removeEventListener(evt, go);
      });
      hydrateThirdParties();
    }
    ['scroll', 'pointerdown', 'touchstart', 'keydown'].forEach(function (evt) {
      window.addEventListener(evt, go, { passive: true });
    });
  }

  function isProductPage() {
    return /\/products\//.test(location.pathname || '');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrateLangifyNow, { once: true });
  } else {
    hydrateLangifyNow();
  }

  function boot() {
    var run = function () {
      runThemeQueue().then(armHeavyOnInteraction);
    };

    if (isProductPage()) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', run, { once: true });
      } else {
        run();
      }
      return;
    }

    setTimeout(run, 150);
  }

  if (isProductPage()) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }
  } else if (document.readyState === 'complete') {
    boot();
  } else {
    window.addEventListener('load', boot, { once: true });
  }

  if (window.Shopify && Shopify.designMode) {
    setTimeout(function () {
      runThemeQueue().then(function () {
        hydrateThirdParties();
        window.ensureSwiper();
      });
    }, 0);
  }
})();
